import React from "react";

export default function SiteLayout({ children }) {
  return (
    <div className="site-shell">
      <header className="nav-bar">
        <div className="nav-left">
          <div className="nav-logo-circle">PAJ</div>
          <span className="nav-title">PELAJ-Forever2025</span>
        </div>

        <nav className="nav-links">
          <a href="#home">Home</a>
          <a href="#save-the-date">Save The Date</a>
          <a href="#event-venue">Event Venue</a>
          <a href="#hire-developer" className="nav-highlight">
            Hire Developer
          </a>
        </nav>
      </header>

      <div className="site-body">{children}</div>

      <footer className="invite-footer">
        <div className="invite-footer-inner">
          <div className="invite-footer-brand">
            <span className="invite-footer-badge">PAJ</span>
            <span className="invite-footer-names">
              Ajoke-Ade &amp; Oluwapelumi
            </span>
          </div>

          <div className="invite-footer-divider" />

          <div className="invite-footer-meta">
            <div>
              Made with <span className="invite-footer-heart">❤️</span> By
              Oluwapelumi Taiwo (Perry)
            </div>
            <div>© 2025 PELAJ-Forever. All rights reserved.</div>
          </div>
        </div>
      </footer>
    </div>
  );
}
